export const CREATE_EXPRESSION_PARAM_INPUTS = Object.freeze({
    DISPLAY_NAME: 'displayName',
    SYSTEM_NAME: 'systemName',
    DESCRIPTION: 'description',
    TPP_TYPE: 'tppType',
    STATUS: 'status'
});

export const CREATE_VELOCITY_PARAM_INPUTS = Object.freeze({
    DISPLAY_NAME: 'displayName',
    SYSTEM_NAME: 'systemName',
    DESCRIPTION: 'description',
    INCLUDE_CURRENT_EVENT: 'includeCurrentEvent',
    STATUS: 'status',
    TPP_TYPE: 'tppType',
    UI_TYPE: 'uiType'
});

export enum VELOCITY_TYPE {
    COUNT = 'Count',
    AVERAGE = 'Average',
    MAX = 'Max',
    MIN = 'Min',
    SUM = 'Sum',
    UNIQUE_COUNT = 'Unique count'
}

export const SELECT_VELOCITY_TYPE_PLACEHOLDER_TEXT = 'Select Velocity Type';

export const ParameterType = Object.freeze({
    SYSTEM: 'system',
    SYSTEM_EXPRESSION: 'system_expression',
    SYSTEM_VELOCITY: 'system_velocity',
    EXPRESSION: 'expression',
    VELOCITY: 'velocity'
});

export const ParameterTppType = Object.freeze({
    STRING: 'string',
    INT: 'int',
    LONG: 'long',
    FLOAT: 'float',
    DOUBLE: 'double'

    // These are not yet supported. See RULE-5367
    // BOOL: 'bool',
    // DATETIME: 'datetime'
});

export const Status = Object.freeze({
    DRAFT: 'draft',
    READY_TO_DEPLOY: 'ready_to_deploy',
    ACTIVE: 'active',
    PRIMING: 'priming',
    READY_TO_DELETE: 'ready_to_delete'
});

export const Source = Object.freeze({
    SYSTEM: 'system',
    USER: 'user'
});

export const Order = Object.freeze({
    ASC: 'asc',
    DESC: 'desc'
});

export const OrderBy = Object.freeze({
    FIELDNAME: 'fieldName',
    MESSAGE: 'message'
});
